﻿export function scrollLeft(scrollElement: HTMLElement, STEP: number) {
    requestAnimationFrame(() => {
        scrollElement.scrollLeft -= STEP;
    });
}

export function scrollRight(scrollElement: HTMLElement, STEP: number) {
    requestAnimationFrame(() => {
        scrollElement.scrollLeft += STEP;
    });
}

export type CalendarBounds = {
    left: number;
    right: number;
};

export type CalendarDragPosition = {
    left: number;
    right: number;
};

export function handleCalendarAutoScrollOnDrag(
    scrollElement: HTMLElement,
    bounds: CalendarBounds,
    position: CalendarDragPosition,
    STEP: number
) {
    if (position.left > 0 && position.left < bounds.left) {
        scrollLeft(scrollElement, STEP);
    } else if (position.right > bounds.right) {
        scrollRight(scrollElement, STEP);
    }
}
